export default "__VITE_ASSET__qZx8609S__"